import queryString from 'query-string';

export async function fetchVerificationRedirectUrl({
  userId,
}: {
  userId: number;
}): Promise<{
  url: string;
}> {
  const url = queryString.stringifyUrl({
    url: `/api/proxy/v3/verification_redirect_url`,
    query: {
      userId: userId.toString(),
    },
  });
  try {
    const response = await fetch(url);
    if (response.ok) {
      return response.json();
    }
    throw new Error(`Could not fetch verification redirect url`);
  } catch (err) {
    throw new Error(err.message);
  }
}

export type FetchVerificationRedirectUrlResponse = {
  url: string;
};
